module.exports = __webpack_public_path__ + "img/logo.90832b77.png";